import React, { useState, useRef, useEffect } from 'react';
import '../css/CustomSelect.css';

const CustomSelect = ({ 
    id, 
    value, 
    onChange, 
    options = [], 
    disabled = false, 
    placeholder = 'Оберіть опцію',
    maxHeight = '250px'
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const selectRef = useRef(null);
    const inputRef = useRef(null);

    // Закриття випадаючого списку при кліку поза ним
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchText('');
            }
        };

        if (isOpen) {
            // Використовуємо setTimeout щоб не спрацював клік, який відкрив dropdown
            setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside);
            }, 0);
        }
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Фокус на input при відкритті
    useEffect(() => {
        if (isOpen && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen]);


    const handleToggle = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
            if (!isOpen) {
                setSearchText('');
            }
        }
    };

    const handleOptionClick = (optionValue) => {
        onChange({ target: { value: optionValue } });
        setIsOpen(false);
        setSearchText('');
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        // Якщо користувач починає вводити текст і список закритий - відкриваємо
        if (!isOpen) {
            setIsOpen(true);
        }
    };

    const handleInputClick = (e) => {
        if (!disabled) {
            // Якщо є текст в інпуті, не змінюємо стан (користувач може редагувати)
            if (searchText.length > 0) {
                return;
            }
            
            // Якщо немає тексту - toggle стан списку
            const newIsOpen = !isOpen;
            setIsOpen(newIsOpen);
            
            // Якщо відкриваємо список, фокусуємося на інпут для зручності
            if (newIsOpen && inputRef.current) {
                setTimeout(() => inputRef.current.focus(), 0);
            }
        }
    };

    // Фільтрація опцій на основі пошукового тексту
    const filteredOptions = searchText
        ? options.filter(option =>
            option.label.toLowerCase().includes(searchText.toLowerCase())
        )
        : options;

    // Знаходимо вибрану опцію для відображення
    const selectedOption = options.find(opt => opt.value === value);
    const displayText = selectedOption ? selectedOption.label : '';

    return (
        <div 
            ref={selectRef} 
            className={`custom-select ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''}`}
            id={id}
        >
            <div className="custom-select-trigger">
                <input
                    ref={inputRef}
                    type="text"
                    className="custom-select-input"
                    value={isOpen ? searchText : displayText}
                    onChange={handleSearchChange}
                    onClick={handleInputClick}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                <span 
                    className="custom-select-arrow"
                    onClick={handleToggle}
                >
                    {isOpen ? '▲' : '▼'}
                </span>
            </div>
            
            {isOpen && !disabled && (
                <div 
                    className="custom-select-dropdown"
                    style={{ maxHeight: maxHeight }}
                >
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option) => (
                            <div
                                key={option.value}
                                className={`custom-select-option ${option.value === value ? 'selected' : ''}`}
                                onClick={() => handleOptionClick(option.value)}
                            >
                                {option.label}
                            </div>
                        ))
                    ) : (
                        <div className="custom-select-option no-results">
                            Нічого не знайдено
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;

